export class LicenceValidityDTO {

    hasLicence: boolean;

    licenceExpired: boolean;

    expires: Date;

    organisationName: string;

    serialNumber: string;
}
